exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".show-more{width:100%;padding:30px 15px 50px;text-align:center}.show-more button{width:100%;background-color:#ffec8b!important;border-radius:20px!important;margin:0!important;padding:0!important;font-size:16px;font-weight:700;color:#3a3a3acf!important}.show-more i{position:relative;top:-2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d8a654c2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/app/contents/SearchProducts.vue
// module id = 570
// module chunks = 0